import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { App } from "./App";
import { iniciarSincronizacaoAutomatica } from "./offline/sync";
import "./estilo.css";

// Sem isso, `registerType: "autoUpdate"` no vite.config.ts não tem efeito algum — a config só diz
// como o SW *deveria* se comportar quando atualizado, mas nada aqui de fato registra o SW nem
// reage a uma versão nova disponível. Descoberto testando um redeploy de verdade: o menu (Agenda/
// Vistorias/Equipe) só apareceu depois de um clear manual de cache+SW no DevTools — sem essa
// chamada, todo usuário logado durante um deploy fica preso na versão antiga até fechar a aba (ou
// pior, indefinidamente, já que é um PWA "instalado"). `immediate: true` verifica update assim
// que a página carrega, e o auto-reload é forçado no callback abaixo — sem prompt de "nova versão
// disponível", o que continua seguro mesmo com a fila offline da Fase 6: a fila vive em
// IndexedDB, não em estado de componente React, então sobrevive ao reload igual sobreviveria a
// fechar e reabrir o app (é exatamente o cenário que a Fase 6 foi feita pra cobrir). Só uma tecla
// digitada bem no instante do reload, ainda sem `onBlur` disparado pra entrar na fila, se perde —
// risco pré-existente, o mesmo de qualquer navegação sem salvar, não algo que a Fase 6 mudou.
const atualizarSW = registerSW({
  immediate: true,
  // Só dispara quando existe de fato um SW novo instalado e esperando — updateSW(true) manda
  // esse SW pular a espera e assumir o controle ANTES do reload; só chamar reload() sozinho
  // deixaria o SW antigo ainda ativo servindo os mesmos assets em cache de novo.
  onNeedRefresh() {
    void atualizarSW(true);
  },
});

iniciarSincronizacaoAutomatica();

const raiz = document.getElementById("root");
if (!raiz) throw new Error("Elemento #root não encontrado");

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>
);
